<template>
  <div class="page-search">
    <SearchHeaderInput v-model="searchValue" @search="onCourseSearchEnter" @clear="clearSessionStorage" @inputChange="clearSessionStorage"/>
    <template v-if="!searchedValue">
      <!--欢迎语-->
      <WelcomeTip/>
      <!--大家都在搜-->
      <EveryoneAsking @search="onCourseSearchEnter"/>
      <!--搜索历史-->
      <SearchHistoryList @search="onCourseSearchEnter" v-model="searchHistory"/>
    </template>
    <template v-else>
      <!--Tab切换-->
      <SearchTab :cur-tab-key.sync="curTabKey" :cur-tab-type.sync="curTabType" @switch="handleItems"/>
      <div v-show="curTabKey === '2'">
        <!--智能助手是否停止服务-->
        <assistant-is-stop v-model="assistantIsStop" v-show="assistantIsStop"/>
        <!--智能搜索的结果-->
        <ai-list v-show="!assistantIsStop" :search-value="searchedValue" :user-info="userInfo" :cur-tab-key="curTabKey" ref="AiList" :assistant-is-stop="assistantIsStop" :cur-tab-type="curTabType" @search="onCourseSearchEnter"/>
      </div>
      <!--普通搜索的结果-->
      <general-list v-show="curTabKey === '1'" :cur-tab-key="curTabKey" ref="GeneralList" :user-info="userInfo" :cur-tab-type.sync="curTabType"
                    :search-value="searchedValue" @handleGetAIList="$refs.AiList.handleGetAIList()" @viewMore="handleItems('2')"/>
    </template>
  </div>
</template>
<script>
import {debounce} from '../../utils/util'

import SearchHeaderInput from './pageSearch/SearchHeaderInput.vue'
import SearchHistoryList from './pageSearch/SearchHistoryList.vue'
import EveryoneAsking from './pageSearch/EveryoneAsking.vue'
import WelcomeTip from './pageSearch/WelcomeTip.vue'
import SearchTab from './pageSearch/SearchTab.vue'
import GeneralList from './pageSearch/generalList.vue'
import AiList from './pageSearch/AiList.vue'
import AssistantIsStop from './pageSearch/assistantIsStop.vue'
import withRouteTracking from '../../utils/withRouteTracking'

const Profile = {
  components: {
    AssistantIsStop,
    AiList,
    GeneralList,
    SearchTab,
    WelcomeTip,
    EveryoneAsking,
    SearchHeaderInput,
    SearchHistoryList,
  },
  data() {
    return {
      searchValue: '', // 输入框的字
      searchedValue: '', // 已经点过搜索的关键词
      curTabKey: '1', // tab 一级默认为普通搜索
      curTabType: '2', // tab 二级默认为搜索课程
      searchHistory: [],
      assistantIsStop: false,
    }
  },
  async mounted() {
    window.sessionStorage.setItem('entrance', '5') // 搜索入口
    let searchStorage = sessionStorage.getItem('searchParams') // 搜索参数
    if (searchStorage) {
      let jsonSearchParams = JSON.parse(searchStorage)
      this.curTabType = jsonSearchParams.curTabType
      this.curTabKey = jsonSearchParams.curTabKey
      this.onCourseSearchEnter(jsonSearchParams.searchContent)
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  watch: {
    searchValue(newval) {
      if (!newval || newval.length <= 0) {
        if (this.$refs.GeneralList) this.$refs.GeneralList.resetData()
        this.searchedValue = ''
        this.clearSessionStorage()
      }
    }
  },
  methods: {
    async handleSetHistory() {
      // 判断搜索值是否有效
      if (!this.searchValue || typeof this.searchValue !== 'string' || this.searchValue.trim() === '') {
        return // 无效值直接返回，不处理
      }
      const {searchHistory} = this
      // 如果已存在，先移除旧项
      const index = searchHistory.indexOf(this.searchValue)
      if (index !== -1) {
        searchHistory.splice(index, 1)
      }
      // 将当前搜索值插入到最前面
      searchHistory.unshift(this.searchValue)
      // 更新本地存储
      localStorage.setItem('searchHistory', JSON.stringify(searchHistory))
    },
    clearSessionStorage() {
      sessionStorage.removeItem('aiResult')
      sessionStorage.removeItem('searchParams')
      sessionStorage.removeItem('paramsQueryTxt')
    },
    async onCourseSearchEnter(e, queryMode) {
      if (e) this.searchValue = e
      if (!this.searchValue) return
      this.searchedValue = this.searchValue
      await this.handleSetHistory()
      const mode = queryMode || {loop: true, redirectAi: true}
      this.$nextTick(() => {
        if (this.curTabKey === '2') {
          this.$refs.AiList.handleGetAIList()
        } else {
          this.$refs.GeneralList.resetData()
          this.$refs.GeneralList.onLoad(mode)
          setTimeout(() => {
            this.$refs.AiList.handleGetAIList()
          })
        }
      })
    },
    handleItems: debounce(function (curTabKey) {
      localStorage.setItem('functionUrl', `/pageSearch`)
      this.$refs.GeneralList.resetData()
      const isFirstTab = curTabKey === 'first'
      const isSecondTab = curTabKey === 'second'
      if (curTabKey && !isFirstTab && !isSecondTab) {
        this.curTabKey = curTabKey
        this.curTabType = '2'
      }
      sessionStorage.setItem('searchParams', JSON.stringify({
        searchContent: this.searchValue,
        curTabType: this.curTabType,
        curTabKey: this.curTabKey
      }))
      let queryMode
      if (isSecondTab) {
        queryMode = {loop: false, redirectAi: false}
      } else if (isFirstTab) {
        queryMode = {loop: true, redirectAi: false}
      }
      this.onCourseSearchEnter(null, queryMode)
    }, 400)
  }
}
export default withRouteTracking(Profile)

</script>
<style lang="less" scoped>
.page-search {
  position: relative;
  width: 100%;
  padding-top: 56px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/home/pageSearch.vue